import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Label } from "./ui/label";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { Cake, DollarSign, Ruler } from "lucide-react"; // Add these imports
import {
  ArrowLeft,
  Heart,
  MessageCircle,
  Share2,
  MapPin,
  GraduationCap,
  Briefcase,
  Shield,
  Star,
  Camera,
  Flag,
  Menu,
  Crown,
  User,
  X,
  Instagram,
} from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { sampleProfiles } from "../constants/profiles";
import { InterestModal } from "./InterestModal";
import { MessageModal } from "./MessageModal";
import { useLocation, useNavigate } from "react-router-dom";
import { CircleSlash } from "lucide-react";
import {
  deleteWithTokenAPI,
  deleteWithTokenBodyAPI,
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import { useSelector, useDispatch } from "react-redux";
import { clearUserState } from "../redux/userSlice";
import { Textarea } from "./ui/textarea"; // Add this import if you have a Textarea component
import { Header } from "./Header";
import { setCurrentPage } from "../redux/navigationSlice.js";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "../styles/ProfileviewPAge.css";
import viewLogo from "../assets/view-logo.png";
import muruganImg from "../assets/Lord Murugan.webp";
import kalasamImg from "../assets/raasi-box-kalasam.png";

export function ProfileViewPage({ onNavigate, profileId }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [sentInterest, setsentInterest] = useState(false);
  const [isInterestSent, setIsInterestSent] = useState(false);
  const [showInterestModal, setShowInterestModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showReportDialog, setShowReportDialog] = useState(false);
  const [SandMeg, setSandMeg] = useState(false);
  const [message, setMessage] = useState("");
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const location = useLocation();
  const id = location.state?.profileId;
  const { name } = useParams();
  const { t, i18n } = useTranslation();
  const userid = data?.userId?.user?._id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [profileDetails, setProfileDetails] = useState({});
  const [profileimage, setProfileimage] = useState("");

  const [fullscreenImage, setFullscreenImage] = useState(null);

  const [isTwoColumn, setIsTwoColumn] = useState(false);
  const [viewMode, setViewMode] = useState("profile");

  // JS-driven sheet scale: fits 800px sheet into available screen width
  const SHEET_W = 800;
  const SHEET_H = 1130;
  const calcScale = () => Math.min(1, (window.innerWidth - 0) / SHEET_W);
  const [sheetScale, setSheetScale] = useState(calcScale);

  const [userSubscription, setUserSubscription] = useState({
    plan_id: "",
    plan_price: "",
    plan_name: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${userid}`
        );
        const subpack = response?.data?.subscription;

        if (subpack) {
          setUserSubscription({
            plan_id: subpack.plan_id || "",
            plan_price: subpack.price || "",
            plan_name: subpack.plan_name || "",
          });
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    if (userid && token) fetchProfile();
  }, [userid, token]);

  useEffect(() => {
    const handleResize = () => {
      setIsTwoColumn(window.innerWidth >= 600 && window.innerWidth < 800);
      setSheetScale(Math.min(1, window.innerWidth / SHEET_W));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const capitalize = (str) => {
    if (typeof str !== "string" || !str) return "";
    else if (str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
    else return str.toUpperCase();
  };

  function timeAgo(dateString) {
    const seconds = Math.floor((new Date() - new Date(dateString)) / 1000);

    if (seconds < 60) return "just now";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    const days = Math.floor(hours / 24);
    return `${days} day${days > 1 ? "s" : ""} ago`;
  }

  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const handleLogout = () => {
    setShowLogoutDialog(true);
  };
  const [header, setHeader] = useState(null);
  const [subpack, setSubsPack] = useState("");
  const [completion, setCompletion] = useState(0);

  const [report, setReport] = useState("");

  console.log(report, "report");

  const fetchReport = async () => {
    if (!id) {
      console.warn("No profileId provided. Skipping fetch.");
      return;
    }
    try {
      const response = await getWithTokenAPI(
        token,
        `/reports/get-by-id?user_id=${userid}`
      );
      if (response) {
        const matchedReports =
          response?.data?.reports?.filter(
            (report) => report.reported_user_id === id
          ) || [];
        setReport(matchedReports?.length > 0);
      } else {
        toast.error(`${t("No Profile Data")}`);
        console.warn("No profile data found for this user.");
      }
    } catch (error) {
      console.error("❌ Error fetching profile details:", error);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${userid}`
        );

        if (sentresponse?.data?.receivers) {
          const receivers = sentresponse.data.receivers;

          // ✅ Check if the viewed profile already received interest from this user
          const isAlreadySent = receivers.some((item) => item.user_id === id);
          setsentInterest(isAlreadySent);
        } else {
          setsentInterest(false);
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setsentInterest(false);
      }
    };

    if (id && token && userid) {
      fetchInterests();
    }
  }, [id, sentInterest]);
  //----------fix image url-------------
  const fixImageUrl = (url) => {
    if (!url) return "";
    return url.replace(
      "s3.eu-north-1.amazonaws.com",
      "s3.ap-south-1.amazonaws.com"
    );
  };
  const [profileData, setprofileData] = useState("");
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${userid}`
        );
        setprofileData(response?.data?.profile?.name);
        setSubsPack(response?.data?.subscription?.plan_name);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    if (id && token) {
      fetchProfile();
    }
  }, [id, token]); // ✅ Proper dependencies

  useEffect(() => {
    const fetchProfileDetails = async () => {
      if (!id) {
        console.warn("No profileId provided. Skipping fetch.");
        // setIsEditing(true)
        return;
      }
      try {
        console.log("Fetching profile for user:", id);
        const response = await getWithTokenAPI(token, `/profile/get_all/${id}`);
        if (response) {
          setProfileDetails(response?.data);
        } else {
          toast.error(`${t("No Profile Data")}`);
          console.warn("No profile data found for this user.");
        }
      } catch (error) {
        console.error("❌ Error fetching profile details:", error);
      }
    };

    if (token && id) {
      fetchProfileDetails();
    }
  }, [token, id]);

  // const handleSendMessage = () => {
  //   setShowMessageModal(true);
  // };
  // const [galleryUrl, setGalleryUrl] = useState([]);
  // console.log(galleryUrl, "GALLERYURL");
  // useEffect(() => {
  //   const fetchpimages = async () => {
  //     const imageresponse = await getWithTokenAPI(
  //       token,
  //       //`/document/user/${id}`
  //       `/document/user/${id}`
  //     );
  //     console.log(
  //       "Imageresponse-------------------------------",
  //       imageresponse?.data
  //     );
  //     setGalleryUrl(imageresponse?.data || []);
  //   };
  //   fetchpimages();
  // }, [id, token]);

  const buttonStyle = {
    width: "100%",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
    borderRadius: "16px",
    transition: "all 0.3s",
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    border: "0",
    padding: "7px 16px",
    background:
      isInterestSent || sentInterest
        ? "linear-gradient(to right, #008000, #005000)" // forest green
        : "linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))", // login button red/rose gradient
    color: "white",
  };

  const handleSendMessage = async () => {
    const payload = {
      sender_id: userid,
      receiver_id: id,
      content: "",
    };
    const response = await postWithTokenAPI(token, `/message/send`, payload);
    if (response?.statusCode == 200) {
      navigate("/messages");
    }
    if (response?.statusCode == 403) {
      setSandMeg(true);
    }
  };

  const RemoveReport = async () => {
    try {
      const response = await deleteWithTokenAPI(
        token,
        `/reports/delete?profile_id=${id}&user_id=${userid}  `
      );

      if (response?.statusCode === 200) {
        toast.success("Report removed successfully!");
        fetchReport();
      } else {
        toast.error("Failed to remove report.");
      }
    } catch (error) {
      console.error("❌ Error removing report:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  // --- Helper: format date as DD/MM/YYYY ---
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleDateString("en-IN");
  };

  // --- Language-aware labels: Tamil only vs bilingual ---
  const isTamil = i18n.language === "ta";
  const L = {
    // Banner
    caste:          isTamil ? "இனம்"               : "Caste / இனம்",
    regDate:        isTamil ? "பதிவு தேதி"          : "Reg. Date / பதிவு தேதி",
    regNo:          isTamil ? "பதிவு எண்"           : "Reg. No / பதிவு எண்",
    // Detail rows
    name:           isTamil ? "பெயர்"              : "Name / பெயர்",
    dob:            isTamil ? "பிறந்த தேதி"         : "Date of Birth / பிறந்த தேதி",
    birthTimePlace: isTamil ? "பிறந்த நேரம் & இடம்" : "Birth Time & Place / பிறந்த நேரம் & இடம்",
    education:      isTamil ? "கல்வி"              : "Education / கல்வி",
    job:            isTamil ? "வேலை"               : "Job / வேலை",
    income:         isTamil ? "மாத வருமானம்"        : "Monthly Income / மாத வருமானம்",
    star:           isTamil ? "நட்சத்திரம்"          : "Star / நட்சத்திரம்",
    rasi:           isTamil ? "இராசி"              : "Rasi / இராசி",
    lagnam:         isTamil ? "லக்னம்"             : "Lagnam / லக்னம்",
    balanceDasa:    isTamil ? "இருப்பு திசை"        : "Balance Dasa / இருப்பு திசை",
    complexionHeight: isTamil ? "நிறம் & உயரம்"     : "Complexion & Height / நிறம் & உயரம்",
    birthOrder:     isTamil ? "பிறப்பு வரிசை"       : "Birth Order / பிறப்பு வரிசை",
    fatherName:     isTamil ? "தந்தை பெயர்"         : "Father's Name / தந்தை பெயர்",
    fatherJob:      isTamil ? "தந்தை வேலை"          : "Father's Job / தந்தை வேலை",
    motherName:     isTamil ? "தாயார் பெயர்"        : "Mother's Name / தாயார் பெயர்",
    expectation:    isTamil ? "எதிர்பார்ப்பு"        : "Expectation / எதிர்பார்ப்பு",
    customs:        isTamil ? "செய்யுமுறை"          : "Customs / செய்யுமுறை",
    property:       isTamil ? "சொத்து விவரம்"       : "Property / சொத்து விவரம்",
    address:        isTamil ? "முகவரி"             : "Address / முகவரி",
    // Sibling table headers
    siblingHeader:  isTamil ? "உடன்பிறப்பு"         : "Sibling / உடன்பிறப்பு",
    totalHeader:    isTamil ? "மொத்தம்"             : "Total / மொத்தம்",
    marriedHeader:  isTamil ? "திருமணம் ஆனவர்"      : "Married / திருமணம் ஆனவர்",
    brothers:       isTamil ? "சகோதரர்"            : "Brothers / சகோதரர்",
    sisters:        isTamil ? "சகோதரி"             : "Sisters / சகோதரி",
    // Zodiac chart titles
    rasiChart:      isTamil ? "இராசி கட்டம்"        : "Rasi Chart / இராசி கட்டம்",
    navamsaChart:   isTamil ? "அம்ச கட்டம்"         : "Navamsa Chart / அம்ச கட்டம்",
    rasiCenter:     isTamil ? "இராசி"              : "Rasi",
    navamsaCenter:  isTamil ? "நவாம்சம்"            : "Navamsa",
  };

  // --- Sibling stats derived from fields ---
  const siblingStr = profileDetails?.professionalProfile?.siblings || "";
  const siblingStats = {
    bTotal: profileDetails?.professionalProfile?.brotherCount ?? "-",
    bMarried: profileDetails?.professionalProfile?.brotherMarried ?? "-",
    sTotal: profileDetails?.professionalProfile?.sisterCount ?? "-",
    sMarried: profileDetails?.professionalProfile?.sisterMarried ?? "-",
  };

  const renderZodiacCellContent = (cellValue) => {
    if (!cellValue) return "";
    if (Array.isArray(cellValue)) {
      return cellValue.filter(Boolean).join(", ");
    }
    return cellValue;
  };

  const renderDetailRow = (label, value) => {
    return (
      <div className="detail-row">
        <span className="detail-label">{label}</span>
        <span className="detail-dots"></span>
        <span className="detail-value">{value || "..................................................."}</span>
      </div>
    );
  };




  return (
    <div className="min-h-screen bg-background pb-10">
      <Toaster position="top-right" />
      
      {/* Header element from web application */}
      <div className="non-printable w-full">
        <Header />
      </div>

      <Helmet>
        <title>Ishwarya matrimony - View Profile</title>
        <meta name="description" content={`Profile page of ${name}`} />
        <meta name="keywords" content={`Profile, ${name}, Ishwarya matrimony`} />
      </Helmet>

      {/* Floating Action Toolbar */}
      <div className="print-sheet-wrapper">
        <div className="print-actions-toolbar non-printable">
          <button
            onClick={() => navigate(-1)}
            className="action-btn message-btn cursor-pointer"
          >
            <ArrowLeft className="w-4 h-4 mb-0.5" />
            {t("Back")}
          </button>
          
          <button
            onClick={() => window.print()}
            className="action-btn print-btn cursor-pointer"
          >
            <Crown className="w-4 h-4 text-yellow-300" />
            {t("Print Color Sheet")}
          </button>

          {profileDetails?.professionalProfile?.gallery?.length > 0 && viewMode === "profile" && (
            <button
              onClick={() => setViewMode("gallery")}
              className="action-btn print-btn cursor-pointer"
              style={{ background: "linear-gradient(to right, #3b82f6, #2563eb)" }}
            >
              <Camera className="w-4 h-4 text-white" />
              <span className="text-white">{t("Gallery Images")}</span>
            </button>
          )}



          <button
            onClick={async () => {
              if (isInterestSent || sentInterest) {
                try {
                  const payload = {
                    from_user_id: userid,
                    to_user_id: id,
                  };
                  const response = await deleteWithTokenBodyAPI(
                    token,
                    `/interest/delete`,
                    payload
                  );

                  if (response?.statusCode === 200) {
                    setIsInterestSent(false);
                    toast.success(`${t("Interest Deleted Successfully")}`);
                  }
                } catch (error) {
                  toast.error(`${t("Already Deleted interest")}`);
                }
              } else {
                try {
                  const payload = {
                    from_user_id: userid,
                    to_user_id: id,
                  };
                  const response = await postWithTokenAPI(
                    token,
                    `/interest/create`,
                    payload
                  );

                  if (response?.statusCode === 200) {
                    setIsInterestSent(true);
                    toast.success(`${t("Interest Sent Successfully")}`);
                  }
                } catch (error) {
                  toast.error(`${t("Interest Already Sent")}`);
                }
              }
            }}
            className={`action-btn interest-btn cursor-pointer ${isInterestSent || sentInterest ? 'sent' : ''}`}
          >
            <Heart className="w-4 h-4" />
            {isInterestSent || sentInterest ? t("Interest Sent") : t("Send Interest")}
          </button>

          <button
            onClick={handleSendMessage}
            className="action-btn message-btn cursor-pointer"
          >
            <MessageCircle className="w-4 h-4" />
            {t("Send Message")}
          </button>

          {report ? (
            <button
              onClick={() => RemoveReport()}
              className="action-btn message-btn opacity-60 cursor-pointer"
            >
              <CircleSlash className="w-4 h-4 text-red-600" />
              {t("Reported")}
            </button>
          ) : (
            <button
              onClick={() => setShowReportDialog(true)}
              className="action-btn report-btn cursor-pointer"
            >
              <Flag className="w-4 h-4" />
              {t("Report")}
            </button>
          )}
        </div>

        {/* Scalable print-sheet container */}
        <div
          className="print-sheet-scaler"
          style={{
            display: viewMode === "profile" ? "block" : "none",
            width: `${SHEET_W * sheetScale}px`,
            height: `${SHEET_H * sheetScale}px`,
            overflow: 'hidden',
            margin: '0 auto',
          }}
        >

          <div
            className="print-sheet"
            style={{
              transform: `scale(${sheetScale})`,
              transformOrigin: 'top left',
              width: `${SHEET_W}px`,
              height: `${SHEET_H}px`,
            }}
          >
            
            {/* Header section matching Shri Varam but renamed to Ishwarya matrimony */}
            <div className="sheet-header">
              <div className="header-left">
                <img
                  src={muruganImg}
                  alt="Lord Murugan"
                  className="header-left-logo"
                />
              </div>
              <div className="header-center">
                <h1>ஐஸ்வர்யா ஜாதகலயா</h1>
                <p className="association-text">கே. எஸ். ரவீந்திரன் வேத சாஸ்திர ஜோதிடர்</p>
                <p className="reg-text">அரசு அங்கீகாரம் பெற்றது அரசு பதிவு எண் : 18 / 2017</p>
                <p className="address-text">எண். 55, கவரை தெரு, மேற்கு மாம்பலம், சென்னை – 600033.<br/>(A.M.R. கல்யாண மண்டபம் அருகில்)</p>
                <p className="contact-text">Mobile: 9884141870, 9884147630 | Website: https://aishwaryamatrimony.prosperoustech.com</p>
              </div>
              <div className="header-right">
                <img
                  src={viewLogo}
                  alt="Ishwarya matrimony"
                  className="header-right-logo"
                />
              </div>
            </div>

            {/* Banner containing Caste, Reg Date, Reg ID */}
            <div className="sheet-banner">
              <span>{L.caste}: {profileDetails?.basicProfile?.caste || "...................................."}</span>
              <span>{L.regDate}: {profileDetails?.basicProfile?.createdAt ? new Date(profileDetails?.basicProfile?.createdAt).toLocaleDateString("en-IN") : "...................."}</span>
              <span>{L.regNo}: {profileDetails?.basicProfile?.registrationNumber || profileDetails?.basicProfile?._id?.slice(-6).toUpperCase() || "................"}</span>
            </div>

            {/* Content Details section */}
            <div className="sheet-details-container">
              {/* Left Details List */}
              <div className="details-left-col">
                {renderDetailRow(L.name,           profileDetails?.basicProfile?.name)}
                {renderDetailRow(L.dob,            formatDate(profileDetails?.basicProfile?.dob))}
                {renderDetailRow(L.birthTimePlace, (profileDetails?.basicProfile?.birthTime || "") + " , " + (profileDetails?.basicProfile?.birthPlace || ""))}
                {renderDetailRow(L.education,      profileDetails?.professionalProfile?.education)}
                {renderDetailRow(L.job,            profileDetails?.professionalProfile?.profession)}
                {renderDetailRow(L.income,         profileDetails?.professionalProfile?.income ? "Rs. " + profileDetails?.professionalProfile?.income + "/-" : "")}
                {renderDetailRow(L.star,           profileDetails?.professionalProfile?.astrology?.natchathiram)}
                {renderDetailRow(L.rasi,           profileDetails?.professionalProfile?.astrology?.rasi)}
                {renderDetailRow(L.lagnam,         profileDetails?.professionalProfile?.astrology?.laknam)}
                {renderDetailRow(L.balanceDasa,    profileDetails?.professionalProfile?.astrology?.dosham || "No Dosham")}
                {renderDetailRow(L.complexionHeight, (profileDetails?.basicProfile?.color || profileDetails?.professionalProfile?.complexion || "") + " / " + (profileDetails?.professionalProfile?.height ? profileDetails?.professionalProfile?.height + " cm" : ""))}
                {renderDetailRow(L.birthOrder,     profileDetails?.basicProfile?.pirapuVarisai || profileDetails?.professionalProfile?.birthOrder || "....................")}
                {renderDetailRow(L.fatherName,     profileDetails?.professionalProfile?.father_name)}
                {renderDetailRow(L.fatherJob,      profileDetails?.professionalProfile?.fatherOccupation || profileDetails?.professionalProfile?.father_occupation)}
                {renderDetailRow(L.motherName,     profileDetails?.professionalProfile?.mother_name)}
                {renderDetailRow("Mother's Job / தாயார் வேலை", profileDetails?.professionalProfile?.motherOccupation)}
                {renderDetailRow(L.expectation,    profileDetails?.preference?.about_partner || "....................")}
                {renderDetailRow(L.customs,        profileDetails?.professionalProfile?.seiMurai || profileDetails?.professionalProfile?.dowry || "....................")}
                {renderDetailRow(L.property,       profileDetails?.professionalProfile?.property_details)}
                {renderDetailRow(L.address,        profileDetails?.basicProfile?.district)}
              </div>

              {/* Right Profile Photo and Siblings Table */}
              <div className="details-right-col">
                <div className="profile-photo-frame">
                  {profileDetails?.basicProfile?.profileImage ? (
                    <img
                      src={profileDetails?.basicProfile?.profileImage}
                      alt={profileDetails?.basicProfile?.name}
                    />
                  ) : (
                    <div className="fallback-avatar">
                      {profileDetails?.basicProfile?.name
                        ?.split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                  )}
                </div>

                {/* Sibling details grid */}
                <table className="sibling-table">
                  <thead>
                    <tr>
                      <th>{L.siblingHeader}</th>
                      <th>{L.totalHeader}</th>
                      <th>{L.marriedHeader}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{L.brothers}</td>
                      <td>{siblingStats.bTotal}</td>
                      <td>{siblingStats.bMarried}</td>
                    </tr>
                    <tr>
                      <td>{L.sisters}</td>
                      <td>{siblingStats.sTotal}</td>
                      <td>{siblingStats.sMarried}</td>
                    </tr>
                  </tbody>
                </table>
                
           
              </div>
            </div>

            {/* Astrology grids section */}
            <div className="zodiac-charts-section">
              {/* Rasi Grid */}
              <div className="zodiac-chart-box">
                <div className="zodiac-chart-title">{L.rasiChart}</div>
                <div className="zodiac-grid">
                  <div className="zodiac-cell zodiac-cell-12">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_12)}</div>
                  <div className="zodiac-cell zodiac-cell-1">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_1)}</div>
                  <div className="zodiac-cell zodiac-cell-2">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_2)}</div>
                  <div className="zodiac-cell zodiac-cell-3">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_3)}</div>
                  
                  <div className="zodiac-cell zodiac-cell-11">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_11)}</div>
                  <div className="zodiac-center-title">
                    <img src={kalasamImg} alt="Kalasam" className="zodiac-center-kalasam" />
                    <span>{L.rasiCenter}</span>
                  </div>
                  <div className="zodiac-cell zodiac-cell-4">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_4)}</div>
                  
                  <div className="zodiac-cell zodiac-cell-10">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_10)}</div>
                  <div className="zodiac-cell zodiac-cell-5">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_5)}</div>
                  
                  <div className="zodiac-cell zodiac-cell-9">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_9)}</div>
                  <div className="zodiac-cell zodiac-cell-8">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_8)}</div>
                  <div className="zodiac-cell zodiac-cell-7">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_7)}</div>
                  <div className="zodiac-cell zodiac-cell-6">{renderZodiacCellContent(profileDetails?.zodiac?.rasi?.House_6)}</div>
                </div>
              </div>

              {/* Navamsa Grid */}
              <div className="zodiac-chart-box">
                <div className="zodiac-chart-title">{L.navamsaChart}</div>
                <div className="zodiac-grid">
                  <div className="zodiac-cell zodiac-cell-12">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_12)}</div>
                  <div className="zodiac-cell zodiac-cell-1">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_1)}</div>
                  <div className="zodiac-cell zodiac-cell-2">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_2)}</div>
                  <div className="zodiac-cell zodiac-cell-3">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_3)}</div>
                  
                  <div className="zodiac-cell zodiac-cell-11">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_11)}</div>
                  <div className="zodiac-center-title">
                    <img src={kalasamImg} alt="Kalasam" className="zodiac-center-kalasam" />
                    <span>{L.navamsaCenter}</span>
                  </div>
                  <div className="zodiac-cell zodiac-cell-4">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_4)}</div>
                  
                  <div className="zodiac-cell zodiac-cell-10">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_10)}</div>
                  <div className="zodiac-cell zodiac-cell-5">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_5)}</div>
                  
                  <div className="zodiac-cell zodiac-cell-9">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_9)}</div>
                  <div className="zodiac-cell zodiac-cell-8">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_8)}</div>
                  <div className="zodiac-cell zodiac-cell-7">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_7)}</div>
                  <div className="zodiac-cell zodiac-cell-6">{renderZodiacCellContent(profileDetails?.zodiac?.navamsa?.House_6)}</div>
                </div>
              </div>
            </div>

            {/* Footer Terms & Legal notice */}
            <div className="sheet-footer">
              <p className="footer-note">
                குறிப்பு: பதிவு கட்டணம் எக்காரணத்தை கொண்டும் திருப்பிக்கொடுக்கப்படாது. 6 மாதத்திற்கு பிறகு புதுப்பிக்க வேண்டும். குடும்ப சம்பந்த பட்ட விபரங்கள் அனைத்தும் இருவீட்டார் பெற்றோரும் தீவிர விசாரணை செய்து கொள்ள வேண்டியது அவசியம்.
              </p>
              <div className="footer-maroon-bar">
                திருமணம் பேசி முடிவு செய்து (திருமண நிச்சயதார்த்தம்) அன்று பேசுகிய கமிஷன் தொகை முழுவதையும் கொடுத்து விட வேண்டும்.
              </div>
            </div>

          </div>
        </div>

        {/* Gallery Section */}
        {profileDetails?.professionalProfile?.gallery?.length > 0 && viewMode === "gallery" && (
          <div className="flex justify-center w-full non-printable">
          <div 
            className="bg-white"
            style={{
              width: '100%',
              maxWidth: '800px',
              border: '8px double #003399',
              padding: '24px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
              minHeight: '80vh'
            }}
          >
            <div className="flex items-center gap-4 mb-6 pb-4 border-b-2" style={{ borderColor: '#003399' }}>
              <button 
                onClick={() => setViewMode("profile")}
                className="p-2 rounded-full hover:bg-gray-200 transition-colors cursor-pointer"
                title={t("Back to Profile")}
              >
                <ArrowLeft className="w-6 h-6" style={{ color: '#003399' }} />
              </button>
              <div className="flex items-center gap-2">
                <Camera className="w-6 h-6" style={{ color: "#003399" }} />
                <h2 className="text-2xl font-bold" style={{ color: "#003399" }}>{t("Gallery Images")}</h2>
              </div>
            </div>
            <div className="grid md:grid-cols-3 grid-cols-2 gap-6">
              {profileDetails.professionalProfile.gallery.map((img, index) => (
                <a 
                  key={index} 
                  href={img.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="aspect-square relative rounded-xl overflow-hidden border border-gray-300 shadow-sm hover:shadow-lg transition-all duration-300 block bg-white"
                >
                  <img
                    src={img.url}
                    alt={`Gallery ${index + 1}`}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
      
      </div>

      {/* Report Dialog */}

      <AlertDialog open={showReportDialog} onOpenChange={setShowReportDialog}>
        <AlertDialogContent className="sm:max-w-lg">
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Report Profile")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t(
                "Please describe why you want to report this user. Our team will review it promptly."
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="space-y-3 mt-2 ml-2 center">
            <Label htmlFor="message" className="text-sm font-medium">
              {t("Reason")}
            </Label>
            <Textarea
              id="message"
              placeholder={t("Enter your reason here...")}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="min-h-[100px]"
            />
          </div>

          <AlertDialogFooter className="mt-4">
            <AlertDialogCancel
              onClick={() => {
                setMessage("");
                setShowReportDialog(false);
              }}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-maroon-gradient hover:bg-maroon-gradient cursor-pointer"
              onClick={async () => {
                if (!message.trim()) {
                  toast.error(
                    `${t("Please enter a reason before submitting.")}`
                  );
                  return;
                }

                try {
                  const payload = {
                    reported_by: userid,
                    profile_id: id,
                    reason: message.trim(),
                  };
                  const response = await postWithTokenAPI(
                    token,
                    "/reports/create",
                    payload
                  );

                  if (response?.statusCode === 200) {
                    toast.success(`${t("Report submitted successfully!")}`);
                    setMessage("");
                    fetchReport(); // NOW THIS WORKS
                    setShowReportDialog(false);
                  } else {
                    toast.error(`${t("Failed to submit report.")}`);
                  }
                } catch (error) {
                  console.error("Error submitting report:", error);
                  toast.error(
                    `${t("Something went wrong. Please try again later.")}`
                  );
                }
              }}
            >
              {t("Submit Report")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={SandMeg} onOpenChange={setSandMeg}>
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔒 {t("Action Not Allowed")}
            </AlertDialogTitle>

            <AlertDialogDescription className="text-gray-600 mt-2">
              {t(
                "This account is blocked. You cannot send a message to this user."
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setSandMeg(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("OK")}
            </AlertDialogCancel>
          </div>
        </AlertDialogContent>
      </AlertDialog>
      {/* Modals */}
      <InterestModal
        isOpen={showInterestModal}
        onClose={() => setShowInterestModal(false)}
        profileName={profileDetails?.basicProfile?.name}
        onSuccess={() => setIsInterestSent(true)}
      />
      <MessageModal
        isOpen={showMessageModal}
        onClose={() => setShowMessageModal(false)}
        profileid={id}
        profileName={profileDetails?.basicProfile?.name}
        userid={userid}
        token={token}
      />
      {fullscreenImage && (
        <Dialog open={true} onOpenChange={() => setFullscreenImage(null)}>
          <DialogContent className="bg-white/80 border-none shadow-none p-0 max-w-[90vw] max-h-[90vh] flex items-center justify-center">
            {/* <button
              onClick={() => setFullscreenImage(null)}
              className="absolute top-4 right-4 bg-black/60 hover:bg-black/80 text-white p-1.5 rounded-full flex items-center justify-center"
            >
              ✕
            </button> */}
            <img
              src={fullscreenImage.url}
              alt="Fullscreen"
              className="rounded-lg max-w-[90vw] max-h-[85vh] object-contain cursor-pointer bg-white"
              onClick={() => setFullscreenImage(null)}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
